import * as React from "react";

// CSS
import "@/styles/components/deliveryOrderDetailCardStyles.css";

// Mui Styles
import { StyledDetailCard } from "@/styles/mui/globalStyles";

// Mui
import Typography from "@mui/material/Typography";
import formatStocktakeStatus from "@/lib/formatStocktakeStatus";

import moment from "moment";
import _ from "lodash";
export default function StocktakeDetailCard(props) {
  const { stocktake } = props;
  const qtyCount = _.reduce(
    stocktake.items,
    (result, value) => {
      if (Number(value.sum) >= 0) {
        return {
          ...result,
          remain: result.remain + Number(value.sum),
        };
      } else {
        return {
          ...result,
          owe: result.owe + Number(value.sum),
        };
      }
    },
    { remain: 0, owe: 0 }
  );
  return (
    <StyledDetailCard onClick={props.onClick}>
      <div className="deliveryOrderDetailContainer">
        <div className="target">
          <div>
            <Typography variant="caption" noWrap component="div">
              員工編號
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {stocktake.staff_code}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              員工名稱
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {stocktake.full_name}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              剩貨總數
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {qtyCount.remain}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              欠貨總數
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {qtyCount.owe}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              盤點時間
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {moment(stocktake.time_created).format("YYYY-MM-DD HH:mm:ss")}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" noWrap component="div">
              提交差異時間
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {stocktake.submitted_at
                ? moment(stocktake.submitted_at).format("YYYY-MM-DD HH:mm:ss")
                : "--"}
            </Typography>
          </div>
        </div>
        <div className="target">
          <div>
            <Typography variant="caption" noWrap component="div">
              狀態
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              component="div"
              sx={{ fontWeight: "bold" }}
            >
              {formatStocktakeStatus(stocktake)}
            </Typography>
          </div>
        </div>
      </div>
    </StyledDetailCard>
  );
}
